module.exports = __webpack_public_path__ + "static/media/welcome-image.5cc8db0d.svg";